import { render, staticRenderFns } from "./vc-collapse.vue?vue&type=template&id=25475b6e&scoped=true&"
import script from "./vc-collapse.vue?vue&type=script&lang=js&"
export * from "./vc-collapse.vue?vue&type=script&lang=js&"
import style0 from "./vc-collapse.vue?vue&type=style&index=0&id=25475b6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25475b6e",
  null
  
)

export default component.exports